"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Constant scales for rendering
var FONT_SIZE_SCALE = 0.5;
var LINE_HEIGHT_SCALE = 0.6;

var transformedSize = function transformedSize(size) {
  /**
   * If we want some fun, we could simply use the following function to map this:
   *   x^3 - 8x^2 + 23x + 8 | x = size
   * (thanks Wolfram Alpha)
   */
  switch (size) {
    case '1x':
      return 24;

    case '2x':
      return 30;

    case '3x':
      return 32;

    case '4x':
      return 36;

    case undefined:
      return 32;

    default:
      return size;
  }
};

var _default = function _default(theme) {
  return {
    root: function root(props) {
      return {
        fontWeight: theme.typography.fontWeight,
        width: transformedSize(props.size),
        height: transformedSize(props.size),
        fontSize: FONT_SIZE_SCALE * transformedSize(props.size),
        lineHeight: LINE_HEIGHT_SCALE * transformedSize(props.size),
        backgroundColor: props.color,
        verticalAlign: 'middle',
        objectFit: 'cover',
        flexShrink: 0
      };
    },
    colorDefault: function colorDefault(props) {
      return {
        backgroundColor: props.color || theme.palette.primary.avatar,
        color: theme.palette.common.white,
        '&.light': {
          backgroundColor: props.color || theme.palette.common.white,
          color: theme.palette.primary.dark
        }
      };
    },
    avatarTextOffset: {
      position: 'relative',
      top: 1
    }
  };
};

exports.default = _default;